<template>
  <header v-show="variant" class="my-4" :class="isLicensingVariant ? 'mb-4 mb-md-5' : 'mb-5'">
    <!-- Marketing Banner -->
    <div v-if="!isAdmin" class="d-flex justify-content-center flex-column">
      <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
      <h1
        v-if="$t(`marketingBanner.title.${variant}`)"
        :class="{ 'mb-2': !isLicensingVariant }"
        class="marketing-banner-title"
        v-html="$t(`marketingBanner.title.${variant}`)"
      />

      <!-- Licensing Variant -->
      <template v-if="isLicensingVariant">
        <b-row class="justify-content-center marketing-banner-content mx-auto mt-2 align-items-baseline">
          <b-col v-for="(content, id) in $t(`marketingBanner.content.${variant}`)" :key="id" class="d-md-flex px-2 px-md-5 mb-2">
            <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
            <p class="marketing-banner-info text-center mb-0" v-html="parseContentInfo(content.info)" />
          </b-col>
        </b-row>
      </template>

      <!-- Other Variants -->
      <template v-else>
        <!-- DESKTOP -->
        <b-row class="d-none d-md-flex justify-content-center marketing-banner-content mx-auto mt-4 align-items-baseline">
          <b-col v-for="(content, id) in $t(`marketingBanner.content.${variant}`)" :key="id" cols="12" md="4" class="px-2 px-md-5">
            <b-img
              class="marketing-banner-content-img w-auto my-auto d-inline d-md-block text-md-center"
              style="max-width: 75%"
              :class="`${variant} ${content.img3x || content.img1x ? '' : 'city-logo'}`"
              :src="content.img3x || content.img1x || getImage(cityLogo)"
              :srcset="content.img3x ? `${content.img1x}, ${content.img2x} 2x, ${content.img3x} 3x` : ''"
              :alt="`${parseContentInfo(content.info)}`"
              fluid
              center
            />
            <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
            <p class="marketing-banner-info text-center pt-2 d-inline d-md-block" v-html="parseContentInfo(content.info)" />
          </b-col>
        </b-row>

        <!-- MOBILE -->
        <b-row v-for="(content, id) in $t(`marketingBanner.content.${variant}`)" :key="id" class="justify-content-center d-flex d-md-none">
          <b-col cols="3">
            <b-img
              style="width: 90%; max-width: 100px"
              class="marketing-banner-content-img mb-3"
              :class="`${variant} ${content.img3x || content.img1x ? '' : 'city-logo'}`"
              :src="content.img3x || content.img1x || getImage(cityLogo)"
              :srcset="content.img3x ? `${content.img1x}, ${content.img2x} 2x, ${content.img3x} 3x` : ''"
              :alt="`${parseContentInfo(content.info)}`"
              fluid
              right
            />
          </b-col>
          <b-col cols="7" class="d-flex align-items-center">
            <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
            <p class="marketing-banner-info" v-html="parseContentInfo(content.info)" />
          </b-col>
        </b-row>
      </template>
    </div>
    <hr v-if="!isAdmin" class="marketing-banner-hr" />
    <pet-header v-if="pet && ((!isAdmin && !isLicensingVariant) || isAdmin)" :is-admin="isAdmin" :pet="pet" />
  </header>
</template>

<script>
import getImage from '@/mixins/getImage';
import PetHeader from './PetHeader';

export default {
  name: 'MarketingBanner',
  components: { PetHeader },
  mixins: [getImage],
  props: {
    variant: {
      type: String,
      required: false,
      default: 'licensing',
      validator: (value) => ['default', 'licensing', 'nonLicensing', 'collars', 'leashes', 'essentials'].includes(value),
    },
    pet: {
      type: Object,
      required: false,
      default: null,
    },
    cityName: {
      type: String,
      required: false,
      default: '...',
    },
    cityLogo: {
      type: String,
      required: false,
      default: '',
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isLicensingVariant() {
      return Boolean(this.variant.toLowerCase() === 'licensing');
    },
  },
  methods: {
    parseContentInfo(contentInfo) {
      contentInfo = !this.isAdmin ? contentInfo?.default ?? contentInfo : contentInfo.admin ?? '';
      contentInfo = contentInfo.replace('{cityName}', this.cityName);
      contentInfo = contentInfo.replace('{petName}', this.pet?.name);
      return contentInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/main';
header {
  .marketing-banner-title {
    font-weight: bold;
    font-size: 1.4rem;
    text-align: center;
    @include media-breakpoint-between(sm, lg) {
      font-size: 1.7rem;
    }
    @include media-breakpoint-up(lg) {
      font-size: 2.4rem;
    }
  }
  .marketing-banner-content {
    max-width: 1024px;
    .marketing-banner-content-img {
      &:not(.licensing) {
        @media (min-width: 576px) and (max-width: 960px) {
          max-height: 100px;
        }
        @media (max-width: 550px) {
          max-height: 70px;
        }
      }
    }
  }
  .marketing-banner-hr {
    border: $dp-gray-3 solid 1px;
  }
}
</style>
